import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconPricingFeature: React.FC<IconProps> = ({ width = 26, height = 26 }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.55 14.6275L4.87778 16.3653L5.16444 18.5286C5.32333 19.7286 6.26667 20.6731 7.46667 20.8331L9.63556 21.1231L11.3722 22.4497C12.3333 23.1842 13.6656 23.1842 14.6267 22.4497L16.3644 21.1219H16.3622L18.5267 20.8353C19.7267 20.6764 20.6711 19.7331 20.8311 18.5331L21.12 16.3642C21.12 16.3653 21.7911 15.4864 22.4478 14.6275C23.1822 13.6664 23.1811 12.3342 22.4478 11.3731L21.1222 9.63417L20.8356 7.47083C20.6767 6.27083 19.7333 5.32639 18.5333 5.16639L16.3633 4.8775L14.6267 3.55083C13.6656 2.81639 12.3333 2.81639 11.3722 3.55083L9.63444 4.8775H9.63667L7.47222 5.16528C6.27222 5.32417 5.32778 6.2675 5.16778 7.4675L4.87778 9.63639C4.87778 9.63528 4.20667 10.5142 3.55 11.3731C2.81667 12.3331 2.81667 13.6664 3.55 14.6275Z"
            fill="#7233FF"
        />
        <path
            d="M16.2267 11L12.3367 14.89L10 12.5556"
            stroke="#FFFFFF"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export default IconPricingFeature;
